import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  MutableValidatedValuegls7jkstsdwb as MutableValidatedValue,
  MutableValidated2ognu5vxf17ur as MutableValidated,
  lens2gvfhjoqnpofs as lens,
  lens2wuprihu5z787 as lens_0,
  lensi9s8q1zaykbw as lens_1,
  lens2dr2mfn274h1a as lens_2,
} from './Validated.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  KMutableProperty025txtn5b59pq1 as KMutableProperty0,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  valueSet3cf2hvvu95f3 as valueSet,
  set1y8eiqnqugbz3 as set,
  getValue6qi464mhg2s5 as getValue,
  setValue39oxnnnmdq4h2 as setValue,
  get_state389x218zizu8a as get_state,
  getValue1utl0kjcx26k4 as getValue_0,
  Reactive1jy75v4li6ldv as Reactive,
  ReactiveValue37mnzha3zo6xb as ReactiveValue,
  Listenable3m4zqvjcbvczy as Listenable,
} from '../../core/coreInterfaces.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { IssueNode2x8c6ia7dmfdz as IssueNode } from './IssueNode.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function validated(_this__u8e3s4, reportTo) {
  reportTo = reportTo === VOID ? null : reportTo;
  var tmp0_elvis_lhs = isInterface(_this__u8e3s4, MutableValidatedValue()) ? _this__u8e3s4 : null;
  return tmp0_elvis_lhs == null ? new (RootMutableValidatedValue())(_this__u8e3s4, reportTo) : tmp0_elvis_lhs;
}
function validated_0(_this__u8e3s4, reportTo) {
  reportTo = reportTo === VOID ? null : reportTo;
  var tmp0_elvis_lhs = isInterface(_this__u8e3s4, MutableValidated()) ? _this__u8e3s4 : null;
  return tmp0_elvis_lhs == null ? new (RootMutableValidated())(_this__u8e3s4, reportTo) : tmp0_elvis_lhs;
}
function MutableReactiveValue$_get_value_$ref_6a9vml(p0) {
  return () => p0.f2();
}
function MutableReactiveValue$_set_value_$ref_n0kkrz(p0) {
  return (_this__u8e3s4) => {
    p0.mam(_this__u8e3s4);
    return Unit_instance;
  };
}
function RootMutableValidatedValue$_get_value_$ref_9j9rny() {
  return (p0) => p0.f2();
}
function RootMutableValidatedValue$_set_value_$ref_w6ztwm() {
  return (p0, p1) => {
    p0.mam(p1);
    return Unit_instance;
  };
}
function RootMutableValidatedValue$_get_value_$ref_9j9rny_0() {
  return (p0) => p0.f2();
}
function RootMutableValidatedValue$_set_value_$ref_w6ztwm_0() {
  return (p0, p1) => {
    p0.mam(p1);
    return Unit_instance;
  };
}
var RootMutableValidatedValueClass;
function RootMutableValidatedValue() {
  if (RootMutableValidatedValueClass === VOID) {
    class $ extends RootValidatedValue() {
      constructor(wrapped, reportTo) {
        super(wrapped, reportTo);
        this.gav_1 = wrapped;
        var tmp = this;
        var tmp0 = this.gav_1;
        var tmp_0 = KMutableProperty0();
        var tmp_1 = MutableReactiveValue$_get_value_$ref_6a9vml(tmp0);
        tmp.hav_1 = getPropertyCallableRef('value', 0, tmp_0, tmp_1, MutableReactiveValue$_set_value_$ref_n0kkrz(tmp0));
      }
      mam(_set____db54di) {
        var tmp0 = this.hav_1;
        var tmp = KMutableProperty1();
        var tmp_0 = RootMutableValidatedValue$_get_value_$ref_9j9rny_0();
        // Inline function 'kotlin.setValue' call
        getPropertyCallableRef('value', 1, tmp, tmp_0, RootMutableValidatedValue$_set_value_$ref_w6ztwm_0());
        tmp0.set(_set____db54di);
        return Unit_instance;
      }
      f2() {
        var tmp0 = this.hav_1;
        var tmp = KMutableProperty1();
        var tmp_0 = RootMutableValidatedValue$_get_value_$ref_9j9rny();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('value', 1, tmp, tmp_0, RootMutableValidatedValue$_set_value_$ref_w6ztwm());
        return tmp0.get();
      }
      oam(thisRef, property) {
        return this.nam((thisRef == null ? true : !(thisRef == null)) ? thisRef : THROW_CCE(), property);
      }
      qam(thisRef, property, value) {
        var tmp = (thisRef == null ? true : !(thisRef == null)) ? thisRef : THROW_CCE();
        return this.pam(tmp, property, (value == null ? true : !(value == null)) ? value : THROW_CCE());
      }
    }
    protoOf($).tak = lens;
    protoOf($).bak = lens_0;
    protoOf($).cak = valueSet;
    protoOf($).gah = set;
    protoOf($).nam = getValue;
    protoOf($).pam = setValue;
    initMetadataForClass($, 'RootMutableValidatedValue', VOID, VOID, [MutableValidatedValue(), RootValidatedValue()], [1]);
    RootMutableValidatedValueClass = $;
  }
  return RootMutableValidatedValueClass;
}
var RootMutableValidatedClass;
function RootMutableValidated() {
  if (RootMutableValidatedClass === VOID) {
    class $ extends RootValidated() {
      constructor(wrapped, reportTo) {
        super(wrapped, reportTo);
        this.mav_1 = wrapped;
      }
      gah(value, $completion) {
        return this.mav_1.gah(value, $completion);
      }
    }
    protoOf($).tak = lens_1;
    protoOf($).bak = lens_2;
    initMetadataForClass($, 'RootMutableValidated', VOID, VOID, [MutableValidated(), RootValidated()], [1]);
    RootMutableValidatedClass = $;
  }
  return RootMutableValidatedClass;
}
var RootValidatedValueClass;
function RootValidatedValue() {
  if (RootValidatedValueClass === VOID) {
    class $ {
      constructor(wrapped, reportTo) {
        this.iav_1 = wrapped;
        var tmp = this;
        var tmp1_elvis_lhs = reportTo == null ? null : reportTo.tat();
        tmp.jav_1 = tmp1_elvis_lhs == null ? new (IssueNode())(null) : tmp1_elvis_lhs;
      }
      vat() {
        return this.jav_1;
      }
      f2() {
        return this.iav_1.f2();
      }
      tah(listener) {
        return this.iav_1.tah(listener);
      }
      iaj() {
        return this.iav_1.iaj();
      }
    }
    protoOf($).qah = get_state;
    protoOf($).nam = getValue_0;
    initMetadataForClass($, 'RootValidatedValue', VOID, VOID, [Reactive(), ReactiveValue(), Listenable()]);
    RootValidatedValueClass = $;
  }
  return RootValidatedValueClass;
}
var RootValidatedClass;
function RootValidated() {
  if (RootValidatedClass === VOID) {
    class $ {
      constructor(wrapped, reportTo) {
        this.nav_1 = wrapped;
        var tmp = this;
        var tmp1_elvis_lhs = reportTo == null ? null : reportTo.tat();
        tmp.oav_1 = tmp1_elvis_lhs == null ? new (IssueNode())(null) : tmp1_elvis_lhs;
      }
      vat() {
        return this.oav_1;
      }
      qah() {
        return this.nav_1.qah();
      }
      tah(listener) {
        return this.nav_1.tah(listener);
      }
      iaj() {
        return this.nav_1.iaj();
      }
    }
    initMetadataForClass($, 'RootValidated', VOID, VOID, [Reactive()]);
    RootValidatedClass = $;
  }
  return RootValidatedClass;
}
//region block: exports
export {
  validated_0 as validatedmmpm5lnzq3lm,
  validated as validated3dw9xce8adqbh,
};
//endregion

//# sourceMappingURL=entrypoints.mjs.map
